/* JumpAbout FAQ accordion â€” product body HTML uses <div class="faq-item"><h3>Q</h3><p>A</p></div>
   Shopify's sanitizer strips <details>/<summary>, so we toggle an `.is-open` class on click. */
(function () {
  function init() {
    const items = document.querySelectorAll(".rte div.faq-item, .product__description-content div.faq-item");
    items.forEach(function (item) {
      const heading = item.querySelector("h3");
      if (!heading) return;
      heading.setAttribute("role", "button");
      heading.setAttribute("tabindex", "0");
      heading.setAttribute("aria-expanded", "false");
      const toggle = function () {
        const open = item.classList.toggle("is-open");
        heading.setAttribute("aria-expanded", open ? "true" : "false");
      };
      heading.addEventListener("click", toggle);
      heading.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggle();
        }
      });
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
